import authSagas from "./auth";
import userManagementSaga from "./userManagement";
import settingsSagas from "./settings";
import customerSagas from "./customer";
import ticketOutSaga from "./ticketOut";
import alertsSaga from "./alerts";
import accountSagas from "./account";
import loanSagas from './loan';
import auditSagas from './audit';

const sagas = [
  customerSagas,
  authSagas,
  userManagementSaga,
  settingsSagas,
  ticketOutSaga,
  alertsSaga,
  accountSagas,
  loanSagas,
  auditSagas
]

const registerSagas = (middleware) => {
  sagas.forEach((saga) => {
    middleware.run(saga)
  })
}

export default registerSagas;